import login from "@/api/login";
export default {
  login,
  // ……
};
